const getLastDayOfMonth = (dateIn) => {
  const date = new Date(dateIn)
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().split('T')[0]
}

export default getLastDayOfMonth
